module.exports = __webpack_public_path__ + "img/3.611a5f85.jpg";